import _ from 'lodash';
import ConversationItemType from 'models/conversation_item_type';
import CustomerView from 'models/location/customer_view';
import { getLatestManualItem } from 'scripts/application/lib/conversation_history_helpers';

export default class FetchAnswerSuggestions {
  constructor(context) {
    this.context = context;
  }

  run(composition) {
    const currentLocation = this.context.stores.currentLocation.get();
    if (!(currentLocation instanceof CustomerView)) {
      return;
    }

    const { conversations, conversationHistory } = this.context.stores.customers.storesFor(currentLocation.customerId);
    if (conversations.isLoading() || conversationHistory.isLoading()) {
      return;
    }

    // Content and ContentType are used for demo and fake backend
    let conversation = conversations.findBy({ id: composition.conversationId });
    const latestItem =
      conversation &&
      getLatestManualItem({
        conversationHistory,
        conversationId: conversation.id,
        filter: item =>
          [ConversationItemType.CONVERSATION_NOTE, ConversationItemType.TASK].indexOf(item.content.type) === -1,
      });
    if (!latestItem || latestItem.isAgentItem()) {
      return;
    }

    let content = '';
    const contentType = latestItem.contentType();
    if (contentType === ConversationItemType.EMAIL) {
      content = latestItem.content.bodyPlain;
    } else if (contentType === ConversationItemType.CHAT_MESSAGE) {
      content = latestItem.content.text;
    } else if (contentType === ConversationItemType.FB_MESSAGE_INCOMING) {
      content = _.get(latestItem, 'content.message.text') || '';
    }

    this.context.gateways.answerSuggestion.fetch(currentLocation.customerId, conversation.id, {
      contentType,
      content,
      conversationItemId: latestItem.id,
      compositionId: composition && composition.id,
      compositionType: composition && composition.contentType(),
    });
  }
}

FetchAnswerSuggestions.actionName = 'FetchAnswerSuggestions'; // for tracking actions in analytics



// WEBPACK FOOTER //
// ./src/scripts/application/actions/answer_suggestions/fetch_answer_suggestions.js